export default "__VITE_ASSET__CAUTAGfc__"